import script from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-custom.vue?vue&type=script&lang=ts&setup=true"

import "./message-custom.vue?vue&type=style&index=0&id=ca0da06e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca0da06e"]])

export default __exports__